const commonjsRegister = require(' commonjsHelpers.js?commonjsRegister');
commonjsRegister("/$$rollup_base$$/node_modules/colors/safe.js", function (module, exports) {
  //
// Remark: Requiring this file will use the "safe" colors API,
// which will not touch String.prototype.
//
//   var colors = require('colors/safe');
//   colors.red("foo")
//
//
var colors = require('./lib/colors');
module['exports'] = colors;

});